/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#reportWrap[_ngcontent-%COMP%]{\n    position: relative;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/practice-report.component.css.shim.ngstyle.js.pre-build-optimizer.js